import React from 'react';
import { createRoot } from 'react-dom/client';
import GomezWebsite from './GomezWebsite';
import './index.css';

const root = createRoot(document.getElementById('root'));
root.render(<GomezWebsite />);
